import Svg from "components/Svg/Svg";
import React from "react";

const LoadingSpinner = () => {
	return (
		<div style={{ flexGrow: "1", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} id="Loading Spinner">
			<div>
				<Svg icon="SPINNER" />
			</div>
		</div>
	);
};

export default LoadingSpinner;
